import React, { useEffect, useState } from "react";
import ControlPanel from "./ControlPanel";
import {
  useSocketClient,
  TUpdateAttributePayload,
} from "../../contexts/SocketClientProvider";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import { IControlLedStripe, TLedMode } from "./types";
import ToggleIconLink from "../../Components/ToggleIconLink";

interface IControlLedStripeProps {
  control: IControlLedStripe;
}

const ControlLedStripe = (props: IControlLedStripeProps) => {
  const { control } = props;
  const [available, setAvailable] = useState<boolean>(
    control.attributes.available === "yes",
  );
  const [modes, setModes] = useState<TLedMode[]>(
    control.attributes.modes || [],
  );
  const [currentMode, setCurrentMode] = useState<number>(
    control.attributes.current_mode || 0,
  );
  const [modeName, setModeName] = useState<string>(
    modes[currentMode]?.name || "",
  );

  const socketClient = useSocketClient();

  useEffect(() => {
    const callback = (payload: TUpdateAttributePayload) => {
      if (payload.id === control.id) {
        if (payload.attribute === "available") {
          setAvailable(payload.value === "yes");
        } else if (payload.attribute === "modes") {
          setModes(payload.value);
        } else if (payload.attribute === "current_mode") {
          setCurrentMode(payload.value);
          setModeName(modes[currentMode].name);
        } else {
          console.log(
            "[ControlLedStripe] UNHANDLED ATTRIBUTE ",
            payload.attribute,
            payload.value,
          );
        }
      }
    };
    socketClient.subscribe(callback, "update_attribute");
    return () => socketClient.unsubscribe(callback, "update_attribute");
  }, [control.id, currentMode, modes, socketClient]);

  const mode: TMode = control.is_enabled ? "on" : "disabled";
  const iconColor = useModeColor(mode);

  if (!available) {
    return <></>;
  }

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={modeName}
    >
      {mode === "on" && (
        <ToggleIconLink
          to={`/controls/details/${control.id}`}
          name="led-stripe"
          color={iconColor}
        />
      )}
    </ControlPanel>
  );
};

export default ControlLedStripe;
